


























































import _ from 'lodash'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Element, ElementStatus, ElementStatusPhase, ElementStatusType, Product } from '@/models'
import { ActionTypes } from '@/store/action-types'
import { Utils } from '@/utils'

@Component({
  components: {
    ElementStatusFilesModal: () => import('@/components/modals/ElementStatusFilesModal.vue')
  }
})
export default class ElementStatusFiles extends Vue {
  @Prop({ required: true, type: Object }) product: Product
  @Prop({ required: true, type: Object }) element: Element

  created() {
    this.loadElementStatusPhases()
  }

  get elementStatusFilesAll() {
    return this.getFilesFromElement(this.element)
  }

  get filesGroupedByElement() {
    return _.groupBy(this.elementStatusFilesAll, 'elementId')
  }

  get percentageByElements() {
    if (!this.filesGroupedByElement) {
      return null
    }

    const percentageByElements: any = {}
    for (const key in this.filesGroupedByElement) {
      const files = Utils.clearFilesFromElement(this.filesGroupedByElement[key])
      if (!files) {
        continue
      }

      const groupedByPhase = _.groupBy(files, 'elementStatusType.phase.elementStatusPhaseId')
      const arrayPercentages: any[] = []
      for (const phase of Object.keys(groupedByPhase)) {
        const filesByPhase = groupedByPhase[phase]

        const percentage = filesByPhase.length / files.length * 100
        arrayPercentages.push({ phase: phase, percentage: percentage })
      }
      percentageByElements[key] = arrayPercentages
    }

    return percentageByElements
  }

  get percentagesByPhaseTotal() {
    if (this.elementStatusPhases.length < 1) {
      return null
    }
    const elementValues = Object.values(this.percentageByElements)
    const phasesWithPercentagePlainArray = elementValues.flat()
    const groupedByPhase = _.groupBy(phasesWithPercentagePlainArray, 'phase')

    const percentagesByPhaseTotal = []
    for (const phase of Object.keys(groupedByPhase)) {
      const percentagesByPhase = groupedByPhase[phase]
      const sumTotalsFilesPonderated = percentagesByPhase.map((item: any) => item.percentage / 100).reduce((a, b) => { return a + b })
      const totalPercentageByPhase = (sumTotalsFilesPonderated / elementValues.length * 100).toFixed(2)
      const phaseCompleteObject = this.elementStatusPhases.find((item: ElementStatusPhase) => item.elementStatusPhaseId === phase)
      percentagesByPhaseTotal.push({ phase: phaseCompleteObject, percentage: totalPercentageByPhase })
    }

    return _.orderBy(percentagesByPhaseTotal, ['phase.orderPhase'])
  }

  get lastPhase() {
    if (!this.percentagesByPhaseTotal) {
      return null
    }

    return this.percentagesByPhaseTotal[this.percentagesByPhaseTotal.length - 1]
  }

  get elementStatusPhases(): ElementStatusPhase[] {
    const elementStatusPhases = this.$store.state.elementStatusPhases.filter((elementStatusPhase: ElementStatusType) =>
      elementStatusPhase.editorialProjectId === this.product.editorialProject &&
      elementStatusPhase.country === this.product.country)
    return elementStatusPhases
  }

  private openModal() {
    this.$bvModal.show('elementStatusFilesModal' + this.element.id)
  }

  private async loadElementStatusPhases() {
    await this.$store.dispatch(ActionTypes.GET_ELEMENT_STATUS_PHASES, { editorialProjectId: this.product.editorialProject, country: this.product.country })
  }

  private getFilesFromElement(element: Element): ElementStatus[] {
    const elementStatusFiles: ElementStatus[] = []

    if (element.elementStatusFiles != null && element.elementStatusFiles?.length > 0) {
      elementStatusFiles.push(...element.elementStatusFiles)
    }

    if (element.elements) {
      for (const children of element.elements) {
        elementStatusFiles.push(...this.getFilesFromElement(children))
      }
    }

    return elementStatusFiles
  }
}
